import $ from 'jquery';

class LanguageSwitch {
    constructor () {
        // Language button
        this.$languageButton = $('.js-language-button');
        this.$languagesList  = $('.js-languages-list');

        // Languages Events
        this.$languageButton.on('click', $.proxy(this.languageToggle, this));
    }

    languageToggle () {
        this.$languagesList.slideToggle(250);

        if (this.$languagesList.hasClass('is-open')) {
            this.$languagesList.blur();
        }

        this.$languageButton.toggleClass('is-open');
    }
}

export default LanguageSwitch;
